{
  "ui": {
    "feedback": "Atsiliepimai",
    "credits": "Kūrėjai",
    "currentMaintainer": "Dabartinis prižiūrėtojas",
    "maintainerPeriod": "Nuo 2026 m.",
    "originalTeam": "Pradinė komanda",
    "creditsCampaigns": "Džiunglės ir Kalėdos",
    "moreSettings": "Daugiau nuostatų",
    "chooseLanguage": "Pasirink kalbą",
    "notebookTools": "Sąsiuvinio įrankiai",
    "visualGuide": "Paveikslėlių vadovas",
    "templeSoon": "Jau greitai",
    "playAdventure": "Žaisti",
    "story": "Istorija",
    "loadingAdventure": "Ruošiamės nuotykiui…",
    "storyOpening": "Mokyklos išvyka į džiungles. Marco ir Sophia tyrinėja aplinką su draugais. Spalvingas paukštis patraukia Marco dėmesį, ir jis seka paskui jį tarp medžių. Staiga jis lieka vienas. Padėk tyrinėtojams rasti kelią!",
    "storyEnding": "Marco ir Sophia kartu pasiekia prarastą šventyklą. Paslaptingas veidas saugo įėjimą. Laukia naujas nuotykis!",
    "blockCategories": "Sąsiuvinio skirtukai",
    "actions": "Veiksmai",
    "loops": "Ciklai",
    "conditions": "Sąlygos",
    "title": "Run Marco! — Nuotykis tavo sąsiuvinyje",
    "home": "Run Marco pradžia",
    "map": "Nuotykių žemėlapis",
    "worlds": "Pasirink nuotykį",
    "notebook": "Mano sąsiuvinis",
    "notebookToggle": "Atverti arba užverti sąsiuvinį",
    "notebookOpen": "Atverti sąsiuvinį",
    "notebookClose": "Stebėti taką",
    "page": "Puslapis {number}",
    "level": "Takas {number}",
    "run": "Pirmyn!",
    "stop": "Sustabdyti",
    "step": "Vienas žingsnis",
    "stepTitle": "Vykdyti vieną komandą",
    "reset": "Grįžti į pradžią",
    "add": "Pridėti",
    "addLabel": "Pasirink bloką",
    "addHint": "Sujunk blokus ir paspausk Žaisti.",
    "undo": "Atšaukti",
    "clear": "Naujas puslapis",
    "hint": "Maža užuomina",
    "help": "Kaip žaisti",
    "settings": "Nuostatos",
    "language": "Žaidimo kalba",
    "blockLanguage": "Blokų kalba",
    "blockLanguageNote": "Blokams gali pasirinkti kitą kalbą.",
    "musicOn": "Įjungti garsą",
    "musicOff": "Išjungti garsą",
    "sound": "Muzika ir garso efektai",
    "speed": "Nuotykio greitis",
    "chooseExplorer": "Pasirink tyrinėtoją",
    "explorer": "Tyrinėtojas",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Užverti",
    "done": "Tyrinėkime!",
    "loading": "Ieškome tako…",
    "loadError": "Nepavyko įkelti nuotykio. Įkelk puslapį iš naujo ir bandyk dar kartą.",
    "imageError": "Nepavyko įkelti kai kurių paveikslėlių. Įkelk puslapį iš naujo.",
    "gemGoal": "Rask brangakmenį",
    "goal": "Rask auksinę žvaigždę",
    "cover": "Apšviesk kiekvieną langelį tik vieną kartą",
    "lit": "Apšviesta langelių: {count} / {total}",
    "explored": "Ištyrinėta takų: {count} / {total}",
    "facing": "Žiūri {direction} {arrow}",
    "boardLabel": "{name} take {level}, žiūri {direction}. {steps}. {objective}.",
    "up": "aukštyn",
    "down": "žemyn",
    "left": "į kairę",
    "right": "į dešinę",
    "steps_one": "{count} žingsnis",
    "steps_other": "{count} žingsnių",
    "blocks_one": "{count} blokas",
    "blocks_other": "{count} blokų",
    "stars_one": "{count} žvaigždė",
    "stars_other": "{count} žvaigždžių",
    "place": "Pridėti blokų",
    "atEnd": "Pabaigoje",
    "insideRepeat": "Kartojimo {number} viduje",
    "insideIf": "Jei {number} viduje",
    "insideElse": "Kitaip {number} viduje",
    "readyFirst": "Mažas žingsnis. Pridėk ėjimo pirmyn bloką ir keliaukime!",
    "ready": "Kur keliausime? Sukurk planą sąsiuvinyje.",
    "back": "Vėl pradžioje. Tavo blokai paruošti naujam bandymui.",
    "empty": "Pirmiausia pridėk bloką į sąsiuvinį.",
    "win": "Radai kelią!",
    "winCover": "Apšvietei taką!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Koks nuotykis!",
    "simpler": "Ar pavyks panaudoti mažiau blokų?",
    "complete": "Takas įveiktas! Geriausios tavo žvaigždės išsaugotos.",
    "next": "Kitas takas",
    "allWorlds": "Daugiau nuotykių",
    "replay": "Žaisti dar kartą",
    "shortGoal": "Beveik! Pridėk dar blokų, kad pasiektum žvaigždę.",
    "shortGem": "Beveik! Pridėk dar blokų, kad pasiektum brangakmenį.",
    "shortCover": "Kai kurie langeliai dar tamsūs. Kaip juos pasieksime?",
    "checking": "Stebime taką…",
    "paused": "Sustabdyta. Žaisti pradės iš naujo nuo pradžios.",
    "going": "Keliaukime!",
    "stepped": "Vienu žingsniu arčiau. Tęsk paspaudęs Vienas žingsnis arba Žaisti.",
    "clueCover": "Pradėk nuo krašto ir apeik visą figūrą. Šuoliu gali peršokti langelį jo neapšvietęs.",
    "clueCondition": "Pažvelk į taką priešais save. Sąlyga padeda tyrinėtojui pasirinkti veiksmą.",
    "clueRepeat": "Kurie žingsniai kartojasi? Įdėk tą seką į kartojimo bloką.",
    "clueForward": "Pirmyn yra kryptis, kuria žiūri tyrinėtojas. Suskaičiuok langelius iki žvaigždės.",
    "clueGem": "Pirmyn yra kryptis, kuria žiūri tyrinėtojas. Suskaičiuok langelius iki brangakmenio.",
    "clueTurn": "Posūkis pakeičia kryptį nepajudant. Sek taką pirštu.",
    "mapNote": "Pasirink taką. Geriausios tavo žvaigždės išlieka.",
    "mapLevel": "Takas {number}: {name}. {stars}.",
    "locked": "Įveik ankstesnį taką, kad atrakintum šį.",
    "soundBlocked": "Paliesk garso mygtuką, kad girdėtum nuotykį.",
    "clearTitle": "Atversti naują puslapį?",
    "clearNote": "Šio tako blokai bus ištrinti. Atšaukti gali juos sugrąžinti.",
    "keep": "Palikti mano blokus",
    "clearConfirm": "Ištrinti blokus",
    "fresh": "Naujas puslapis. Kur mus nuves kitas tavo planas?",
    "localProgress": "Tavo pažanga saugoma šiame įrenginyje.",
    "helpBuild": "Sukurk planą",
    "helpBuildText": "Vilk blokus į sąsiuvinį ir sujunk arba paliesk bloką, kad jį pridėtum. Pasirink kartojimo vidų, kad į ciklą pridėtum žingsnių.",
    "helpTurn": "Sek savo tyrinėtoją",
    "helpTurnText": "Pirmyn seka jo žvilgsnį. Kairė ir dešinė pasuka vietoje. Šuolis įveikia du langelius.",
    "helpTry": "Bandyk, stebėk ir bandyk vėl",
    "helpTryText": "Paspausk Žaisti, kad išbandytum planą, arba Vienas žingsnis vienai komandai. Lenktas mygtuko rodyklės ženklas grąžina į pradžią ir palieka blokus.",
    "helpWorlds": "Kiekvienas nuotykis turi tikslą",
    "helpWorldsText": "Džiunglėse rask brangakmenį. Kalėdų nuotykyje kiekvieną laisvą langelį apšviesk vieną kartą. Šventykloje ir Egėjo jūroje atlik taisymus, įvykdyk rodomus tikslus ir pasiek išėjimą.",
    "noTrail": "Ten nėra tako! Pabandyk pasukti prieš žengdamas.",
    "broken": "Tas tiltas sulūžęs. Ar gali jį peršokti?",
    "blocked": "Kažkas užstoja kelią. Pabandyk šokti arba rinkis kitą kelią.",
    "alreadyLit": "Tas langelis jau šviečia. Kiekvieną langelį aplankyk tik vieną kartą.",
    "loopError": "Šis planas kartojasi be galo. Pabandyk pakeisti ciklą.",
    "repeatError": "Pasirink kartojimų skaičių nuo 1 iki 99.",
    "unsupported": "Pašalink nepalaikomą bloką ir bandyk dar kartą.",
    "connect": "Sujunk blokus į vieną grandinę ir paspausk Žaisti.",
    "path": "takas",
    "steps_few": "{count} žingsniai",
    "blocks_few": "{count} blokai",
    "stars_few": "{count} žvaigždės",
    "steps_many": "{count} žingsnio",
    "blocks_many": "{count} bloko",
    "stars_many": "{count} žvaigždės",
    "backpack": "Kuprinė",
    "templeGems": "Šventyklos brangakmeniai",
    "gemsCollected": "Brangakmeniai: {count} / {total}",
    "gemsReady": "Visi brangakmeniai surinkti!",
    "aegeanTitle": "Egėjo jūros paslaptys",
    "harbour": "Uostas",
    "aegeanDescription": "Tyrinėk uostą: taisyk stoteles, pakartotinai naudok paprogrames ir su kiekviena užduotimi perduok skaičių.",
    "templeBetaNote": "Beta · Atnaujiname galvosūkius ir pamokas",
    "aegeanBetaNote": "Beta · Pirmieji 3 uosto lygiai",
    "seasonal": "Sezoninis nuotykis",
    "choosePreview": "Pasirink bandomąjį lygį",
    "repairs": "Pataisyta",
    "reachExit": "Pasiek išėjimą",
    "taskRequirements": "Užduoties tikslai",
    "lessonGuided": "Pratimas su pagalba · užbaik pateiktą programą",
    "lessonRepair": "Klaidų taisymas · pataisyk pateiktą programą",
    "lessonChallenge": "Iššūkis · sukurk savo programą",
    "acc_define_parameter": "Paprogramė",
    "acc_call_argument": "Kviesti paprogramę",
    "acc_repeat_parameter": "Kartoti pagal įvestį",
    "parameter": "parametras",
    "argument": "perduoti",
    "callInput": "Šio kvietimo įvestis",
    "inputWaiting": "Paleisk programą arba vykdyk po vieną komandą, kad pamatytum kitą įvestį.",
    "argumentMismatch": "Paprogramei su parametru reikia kvietimo su skaičiumi. Be parametro naudok įprastą kvietimą.",
    "unsetParameter": "Parametrą naudok tik jį gaunančioje paprogramėje. Parametrai atskirti nuo bendrosios atminties.",
    "memoryObjective": "Patikrink taisymų žurnalą ir išėjimo reikalavimus. Tinka kiekviena programa, kuri juos įvykdo.",
    "gate": "Kelias užblokuotas. Patikrink nebaigtus remonto darbus.",
    "noPickup": "Prieš paimdamas įrankį, atsistok jo vietoje.",
    "creditLead": "Komandos vadovavimas ir programavimas",
    "creditArt": "Iliustracijos ir aplinka",
    "creditAnimation": "Animacija",
    "creditUX": "Sąsajos ir naudotojo patirties dizainas",
    "creditDesign": "Žaidimo dizainas",
    "creditStory": "Istorijos kūrimas",
    "creditAudio": "Muzika ir garso inžinerija",
    "lightLamp": "Uždek lempą",
    "oilLamp": "Aliejinė lempa",
    "dustyStation": "dulkėta stotelė",
    "betaLabel": "Beta",
    "noLamp": "Prieš uždegdamas lempą, atsistok ant neuždegtos lempos langelio.",
    "collected": "Įrankis paimtas · paruoštas naudoti",
    "dustyPrompt": "Prieš naudodamas teptuką, atsistok ant dulkėtos stotelės.",
    "lampMissing": "Pirmiausia paimk aliejinę lempą. Pažiūrėk kuprinėje.",
    "recursiveRoutine": "Ši paprogramė iškviečia pati save. Naudok kitą paprogramę; rekursiniai iškvietimai dar neprieinami."
  },
  "content": {
    "jungle.title": "Džiunglių ekspedicija",
    "jungle.description": "Sek taku į prarastą šventyklą.",
    "jungle-1": "Pirmieji žingsniai",
    "jungle-2": "Truputį toliau",
    "jungle-3": "Už kampo",
    "jungle-4": "Pakeisk kryptį",
    "jungle-5": "Sek taku",
    "jungle-6": "Naujas maršrutas",
    "jungle-7": "Nauji takai",
    "jungle-8": "Džiunglių kryžkelė",
    "jungle-9": "Rask savo kelią",
    "jungle-10": "Galvok į priekį",
    "jungle-11": "Ilgas takas",
    "jungle-12": "Vingiuotas kelias",
    "jungle-13": "Drąsus šuolis",
    "jungle-14": "Pasirodo sekos",
    "jungle-15": "Kartok ritmą",
    "jungle-16": "Pasirink taką",
    "jungle-17": "Pažvelk prieš šokdamas",
    "jungle-18": "Skaityk taką",
    "jungle-19": "Gudrus aplinkkelis",
    "jungle-20": "Po medžių lajomis",
    "jungle-21": "Tiltų statytojas",
    "jungle-22": "Anapus upės",
    "jungle-23": "Tyrinėk griuvėsius",
    "jungle-24": "Akmuo ir medis",
    "jungle-25": "Didesnis šuolis",
    "jungle-26": "Sek užuominomis",
    "jungle-27": "Aukštyn",
    "jungle-28": "Tyrinėk toliau",
    "jungle-29": "Vingiuoti takai",
    "jungle-30": "Slaptas sodas",
    "jungle-31": "Paslėptos sekos",
    "jungle-32": "Senoviniai takai",
    "jungle-33": "Paskutiniai posūkiai",
    "jungle-34": "Šventyklos link",
    "jungle-35": "Beveik atvykome",
    "jungle-36": "Prarasta šventykla",
    "winter.title": "Žiemos takas",
    "winter.description": "Palik šviesą kiekviename pėdsake.",
    "winter-1": "Žingsniai sniege",
    "winter-2": "Kita kryptis",
    "winter-3": "Sušalę kampai",
    "winter-4": "Ilgas aplinkkelis",
    "winter-5": "Snaigė",
    "winter-6": "Žiemos ciklai",
    "winter-7": "Ledo tyrinėtojas",
    "winter-8": "Vingiai ir posūkiai",
    "winter-9": "Ledinė logika",
    "winter-10": "Sekų ieškotojas",
    "winter-11": "Tako meistras",
    "winter-12": "Žiemos stebuklas",
    "temple.title": "Prarasta šventykla",
    "temple.description": "Keturiasdešimt sujungtų kambarių. Atkurk dangaus prietaisą naudodamas įrankius, atmintį ir savo paprogrames."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Šiukšlinė tuščia",
    "OPEN_TRASH": "Atverti šiukšlinę",
    "BLOCK_LABEL_BEGIN_STACK": "Grandinės pradžia",
    "WORKSPACE_LABEL_1_STACK": "1 blokų grandinė",
    "WORKSPACE_LABEL_MANY_STACKS": "Blokų grandinių: %1",
    "ARIA_TYPE_FIELD_NUMBER": "skaičius",
    "ARIA_TYPE_FIELD_DROPDOWN": "išskleidžiamasis sąrašas",
    "ARIA_TYPE_FIELD_IMAGE": "paveikslėlis",
    "WORKSPACE_LABEL_PLAIN": "Mano sąsiuvinis",
    "FIELD_LABEL_EDIT_PREFIX": "Keisti: %1",
    "BLOCK_LABEL_HAS_INPUT": "turi įvestį",
    "BLOCK_LABEL_HAS_INPUTS": "turi įvesčių",
    "BLOCK_LABEL_HAS_BRANCHES": "šakų: %1",
    "FIELD_LABEL_OPTION_INDEX": "Pasirinkimas %1",
    "INPUT_LABEL_EMPTY": "Tuščia",
    "BLOCK_LABEL_DISABLED": "išjungta",
    "BLOCK_LABEL_COLLAPSED": "sutraukta",
    "BLOCK_LABEL_BEGIN_PREFIX": "Pradžia: %1",
    "INPUT_LABEL_END_STATEMENT": "Pabaiga: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "tekstas",
    "ARIA_TYPE_FIELD_INPUT": "įvestis",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "įvesties vardas",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "paprogramės vardas"
  }
}
